import { Actions } from './transporteurActions';

/**
 * Etat initial
 */
const initialState = {
    suggestions: {
        items: [],
        isLoading: false,
        value: '',
        selectedId: 0
    },
    transporteurs: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour le domaine "transporteur"
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {

        case Actions.FETCH_TRANSPORTEURS_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isLoading: true }
            };
        case Actions.FETCH_TRANSPORTEURS_SUCCESS:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_TRANSPORTEURS_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isLoading: false, error: action.error }
            };

        case Actions.FETCH_SUGGESTIONS_TRANSPORTEUR_REQUEST:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: true }
            };
        case Actions.FETCH_SUGGESTIONS_TRANSPORTEUR_SUCCESS:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [...action.transporteurs], isLoading: false }
            };
        case Actions.FETCH_SUGGESTIONS_TRANSPORTEUR_FAILURE:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: false, error: action.error }
            };
        case Actions.CLEAR_SUGGESTIONS_TRANSPORTEUR:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [], isLoading: false }
            };
        case Actions.SET_TRANSPORTEUR_VALUE:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: action.value, selectedId: action.selectedId }
            };
        case Actions.CLEAR_TRANSPORTEUR_VALUE:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: '', selectedId: 0 }
            };


        default:
    }

    return state;
};

export default reducer;